import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';


export class PlanCategory {
  id : string;
  text : string;
  value : string;
}

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class PlanCategoryService {
  constructor(private http: HttpClient) {}

  getPlanCategoryList(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/planCategory';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as PlanCategory[]),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
}
